import"react";import r from"../../../prop-types/index.js";import{isPdf as e}from"./shared/propTypes.js";var s=r.oneOfType([r.string,r.arrayOf(r.any)]);r.shape({dest:s,items:r.arrayOf(r.shape({dest:s,title:r.string})),title:r.string}).isRequired,r.func,e.isRequired;
//# sourceMappingURL=OutlineItem.js.map
